<script setup>
import { onBeforeUnmount, onBeforeMount } from "vue";
import { useStore } from "vuex";
import cookie from '../assets/js/cookies.js';

import axios from "axios";
const body = document.getElementsByTagName("body")[0];

import logo from "@/assets/img/1.png";
import logoWhite from "@/assets/img/logo-financas-branco-transparente.png";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const store = useStore();

const submit = () => {

  let data = new FormData();

  store.state.name.hasError = false;
  store.state.email.hasError = false;
  store.state.password.hasError = false;
  store.state.terms.hasError = false;

  data.append('name', store.state.name.value);
  data.append('email', store.state.email.value);
  data.append('password', store.state.password.value);
  data.append('accept_terms', store.state.terms.checked);

  axios.post('/users', data)
  .then(res => {

    if(res.data.error){

      let messages = res.data.messages;
      
      Object.entries(messages).forEach((value) => {
        
        if(value[0] == 'name'){
          store.state.name.hasError = true;
          store.state.name.messageError = value[1];
        }

        else if(value[0] == 'email'){
          store.state.email.hasError = true;
          store.state.email.messageError = value[1];
        }

        else if(value[0] == 'password'){
          store.state.password.hasError = true;
          store.state.password.messageError = value[1];
        }

        else if(value[0] == 'accept_terms'){
          store.state.terms.hasError = true;
          store.state.terms.messageError = value[1];
        }

      })

    }
    else{

      let email = store.state.email.value;
      let password = store.state.password.value;

      login(email, password);
      
    }
    
  })
  .catch(err => {
    console.error(err.message); 
  })

}

const login = (email, password) => {

  let data = new FormData();

  let device = getDeviceName();

  data.append('email', email);
  data.append('password', password);
  data.append('remember', false);
  data.append('device', device);
  
  axios.post('/auth',data)
  .then(res => {

    if(res.data.error){

    let messages = res.data.messages;

      Object.entries(messages).forEach((value) => {
      
        if(value[0] == 'name'){
          store.state.name.hasError = true;
          store.state.name.messageError = value[1];
        }

        else if(value[0] == 'email'){
          store.state.email.hasError = true;
          store.state.email.messageError = value[1];
        }

        else if(value[0] == 'password'){
          store.state.password.hasError = true;
          store.state.password.messageError = value[1];
        }

        else if(value[0] == 'accept_terms'){
          store.state.terms.hasError = true;
          store.state.terms.messageError = value[1];
        }

      })

    }
    else{

      cookie.add('user_agive_session', res.data, 86400);
      cookie.add('user_agive_email', store.state.email.value, 86400);

      window.location.href = '/inicio';

    }

  })
  .catch(err => {
    console.error(err); 
  })

}

onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");

  store.state.name = {
    hasError: false,
    messageError: '',
    value: '',
  };

  store.state.email = {
    hasError: false,
    messageError: '',
    value: '',
  };

  store.state.password = {
    hasError: false,
    messageError: '',
    value: '',
  };

  store.state.terms = {
    hasError: false,
    messageError: '',
    checked: false,
  };

  store.state.user = {
    isLogged: false,
    id: 0,
    accept_terms: "",
    account_type: '',
    birthdate: '',
    email: '',
    sex: '',
    status: ''
  }

});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-default");
});

const iosDeviceMapping = new Map([
  ["320x480", "IPhone 4S, 4, 3GS, 3G, 1st gen"],
  ["320x568", "IPhone 5, SE 1st Gen,5C, 5S"],
  ["375x667", "IPhone SE 2nd Gen, 6, 6S, 7, 8"],
  ["375x812", "IPhone X, XS, 11 Pro, 12 Mini, 13 Mini"],
  ["390x844", "IPhone 13, 13 Pro, 12, 12 Pro"],
  ["414x736", "IPhone 8+"],
  ["414x896", "IPhone 11, XR, XS Max, 11 Pro Max"],
  ["428x926", "IPhone 13 Pro Max, 12 Pro Max"],
  ["476x847", "IPhone 7+, 6+, 6S+"],
  ["744x1133", "IPad Mini 6th Gen"],
  [
    "768x1024",
    "IPad Mini (5th Gen), IPad (1-6th Gen), iPad Pro (1st Gen 9.7), Ipad Mini (1-4), IPad Air(1-2)  ",
  ],
  ["810x1080", "IPad 7-9th Gen"],
  ["820x1180", "iPad Air (4th gen)"],
  ["834x1194", "iPad Pro (3-5th Gen 11)"],
  ["834x1112", "iPad Air (3rd gen), iPad Pro (2nd gen 10.5)"],
  ["1024x1366", "iPad Pro (1-5th Gen 12.9)"],
]);

const desktopDeviceMapping = new Map([
  ["Win32", "Windows"],
  ["Linux", "Linux"],
  ["MacIntel", "Mac OS"],
  ["Windows", "Windows"]
]);

// get device name for android
const getAndroidDeviceName = () => {
  const androidUserAgentString = window.navigator.userAgent.slice(window.navigator.userAgent.indexOf("Android"));
  const androidDeviceName = androidUserAgentString.slice(androidUserAgentString.indexOf("; ") + 1, androidUserAgentString.indexOf(")"));
  if (androidDeviceName) {
    return androidDeviceName.trim().split(" ")[0];
  }

  return "Android";
};

// get device name for ios
const getIosDeviceName = () => {
  const screenResolution = window.screen.width + 'x' + window.screen.height;
  const device = iosDeviceMapping.get(screenResolution);
  if (device) {
    return device;
  }
  return "Iphone";
};

// get device name for desktop
const getDesktopDeviceName = () => {
  const platform = navigator?.userAgentData?.platform || navigator?.platform || "unknown";
  let device = desktopDeviceMapping.get(platform) ?? "Unknown";
  return device;
};

const getDeviceName = () => {

  let device = "";
  
  // check if mobile device
  const isMobileDevice = window.navigator.userAgent
    .toLowerCase()
    .includes("mobi");

  if (isMobileDevice) {
    if (window.navigator.userAgent.includes("Android")) {
      device = getAndroidDeviceName();
    } else {
      device = getIosDeviceName();
    }
  } else {
    device = getDesktopDeviceName();
  }
  
  return device;

}
</script>
<template>

  <main class="mt-0 main-content"
      v-bind:class="{
                      'bg-azul-petroleo': !darkMode
                  }"
  >
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div
              class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-colum rounded"
              v-bind:class="{
                            'bg-white': !darkMode
                        }"
            >
              <div class="card card-plain">
                <div class="pb-0 card-header text-center" 
                v-bind:class="{
                            'bg-white': !darkMode
                        }">
                  <img :src="!darkMode ? logo : logoWhite" alt="" class="logo-sidebar-login">
                  <h4 class="font-weight-bolder fc-azul-petroleo">{{ t('message.singup.account_creation') }}</h4>
                  <p class="mb-0 text-dark">{{ t('message.singup.account_creation_subtitle') }}</p>
                </div>
                <div class="card-body">
              <div class="mb-3">
                <input 
                  type="text" 
                  class="form-control form-control-lg" 
                  id="name" 
                  v-model="store.state.name.value" 
                  :placeholder="t('message.global.full_name')"
                  :class="store.state.name.hasError ? 'is-invalid' : ''"
                >
                <div id="nameFeedback" class="invalid-feedback">
                  {{ store.state.name.messageError }}
                </div>
              </div>
                <div class="mb-3">
                  <input 
                    type="email" 
                    class="form-control form-control-lg" 
                    id="email" 
                    v-model="store.state.email.value" 
                    :placeholder="t('message.global.email')"
                    :class="store.state.email.hasError ? 'is-invalid' : ''"
                  >
                  <div id="emailFeedback" class="invalid-feedback">
                    {{ store.state.email.messageError }}
                  </div>
                </div>
                <div class="mb-3">
                  <input 
                    type="password" 
                    class="form-control form-control-lg" 
                    id="password" 
                    v-model="store.state.password.value" 
                    :placeholder="t('message.global.password')"
                    :class="store.state.password.hasError ? 'is-invalid' : ''"
                  >
                  <div id="passwordFeedback" class="invalid-feedback">
                    {{ store.state.password.messageError }}
                  </div>
                </div>
                <div class="mb-3">
                  <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="checkbox" 
                        id="termsCheck" 
                        v-model="store.state.terms.checked"
                        :class="store.state.terms.hasError ? 'is-invalid' : ''"
                      >
                      <label class="form-check-label" for="termsCheck">
                        {{ t('message.singup.read_terms') }}
                        <a href="javascript:;" class="text-dark font-weight-bolder"
                          >{{ t('message.singup.terms') }}</a
                        >
                      </label>
                      <div id="termsCheckFeedback" class="invalid-feedback">
                        {{ store.state.terms.messageError }}
                      </div>
                      
                  </div>
                  
                </div>
                
                <div class="text-center">
                  <button
                    class="my-4 mb-2 btn-lg btn bg-mostarda w-100 text-white"
                    @click="submit()"
                  >
                    {{ t('message.singup.start_use') }}
                  </button>
                  
                </div>
                <p class="text-sm mt-3 mb-0">
                  {{ t('message.singup.has_account') }}
                  <router-link :to="'/login'" class="text-dark font-weight-bolder">{{ t('message.singup.want_sign') }}</router-link>
                  
                </p>
            </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
